import script from "./PrintDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PrintDialog.vue?vue&type=script&setup=true&lang=js"

import "./PrintDialog.vue?vue&type=style&index=0&id=58be5213&lang=css"

const __exports__ = script;

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/.pnpm/vue-cli-plugin-quasar@5.0.2/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner,QIcon});
